import { Dialog } from 'primereact/dialog'
import React, { useContext, useState } from 'react'
import { Button } from 'primereact/button'
import { useMountEffect } from 'primereact/hooks'
import { isEmpty } from 'lodash'
import { CommonContext } from '../common/context/commonContext'
import { LocationSector, SectorDialogProps } from '../../types/inventory'
import { InputText } from 'primereact/inputtext'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const SectorAddDialog = (props: SectorDialogProps) => {
    const { $toast, $http, $alert } = useContext(CommonContext)
    const { t } = useTranslation()
    const [sector, setSector] = useState<LocationSector>({
        centerId: '',
        areaId: '',
        sectorId: '',
        sectorNm: '',
    })

    useMountEffect(() => {
        if (!props.visible) return
        if (!props.data) return
        console.log(props.data)
        setSector(props.data)
    })

    const onClickSave = async () => {
        if (!sector) return

        if (isEmpty(sector.areaId)) {
            $alert({
                icon: 'info',
                title: t(tokens.inventory.add_sector),
                text: t(tokens.inventory.location_area_must_be_assigned),
            })
            return
        }
        if (isEmpty(sector.sectorNm)) {
            $alert({
                icon: 'info',
                title: t(tokens.inventory.add_sector),
                text: t(tokens.inventory.enter_location_sector_name),
            })
            return
        }

        const isConfirm = await $alert({
            icon: 'info',
            title: t(tokens.inventory.add_sector),
            text: t(tokens.inventory.confirm_location_sector_addition),
            isConfirm: true,
        })
        if (!isConfirm) return
        console.log(sector)
        const result = await $http().put('/inventory/add-sector', sector)
        if (result) {
            $toast({ title: t(tokens.common.success), text: t(tokens.inventory.sector_added), icon: 'success' })
            props.onHide(true)
        }
    }

    const onChange = (type: string, value: string) => {
        setSector({
            ...sector,
            [type]: value,
        })
    }

    const header = (title: string) => {
        return <div>{title}</div>
    }

    return (
        <Dialog
            header={header(t(tokens.inventory.add_sector))}
            visible={props.visible}
            onHide={() => props.onHide(false)}
            closable={false}
            contentClassName="pb-0"
        >
            {sector && (
                <div className="grid">
                    <div className="col-12 flex rdms-text-primary mt-2 grid py-0">
                        <div className="col-4 font-bold">t(tokens.inventory.zone)(Area)</div>
                        <div className="col-8 font-bold pl-3">{sector.areaId}</div>
                    </div>
                    <div className="col-4 flex pt-1 font-bold mt-2 align-items-center">{t(tokens.inventory.sector_name)}</div>
                    <div className="col-8 flex pt-1 mt-2">
                        <InputText
                            value={sector.sectorNm}
                            className="p-inputtext w-full text-md"
                            placeholder={t(tokens.inventory.enter_sector_name)}
                            onChange={(e) => onChange('sectorNm', e.currentTarget.value)}
                        />
                    </div>
                    <div className="col-6 flex mb-2 pl-0">
                        <Button
                            className="w-full p-button-secondary"
                            label={t(tokens.common.cancel)}
                            size="large"
                            onClick={() => props.onHide(false)}
                        />
                    </div>
                    <div className="col-6 flex mb-2 pr-0">
                        <Button className="w-full p-button-success" label={t(tokens.common.add)} size="large" onClick={onClickSave} />
                    </div>
                </div>
            )}
        </Dialog>
    )
}

export default SectorAddDialog
